import { useQuery } from "@tanstack/react-query";
import { getReadingPerformance } from "src/api/readingPerformance/getReadingPerformance";
import { ReadingPerformance } from "./types";
import { QueryClientScope } from "../types";
import { getEnv } from "src/config/index";
import { useFeatureToggle } from "src/api/featureToggling/useGetFeatureToggle";
import { FeatureToggleKey } from "src/api";
import { getServices } from "src/logs";

const { logger } = getServices();

const refreshInterval =
getEnv().REACT_APP_BE_REFRESH_INTERVAL ||
  (() => {
    logger.logError({message : "REACT_APP_BE_REFRESH_INTERVAL environmental variable not set"})
    throw new Error("REACT_APP_BE_REFRESH_INTERVAL environmental variable not set");
  })();

export const useGetReadingPerformance = (dateFrom: string, dateTo: string) => {
  const { data : logsDetailedFeature} = useFeatureToggle(FeatureToggleKey.LogsDetailed);
  return useQuery<ReadingPerformance, Error>({
    queryKey: [QueryClientScope.ReadingPerformance, dateFrom, dateTo],
    queryFn: () => getReadingPerformance(dateFrom, dateTo, logsDetailedFeature?.isEnabled),
    refetchOnWindowFocus: false,
    retry: 3, // Retry 3 times
    retryDelay: 3000, // Wait 3 seconds between each retry (in milliseconds)
    staleTime: 5 * 60 * 1000,
    refetchInterval: parseInt(refreshInterval),
  });
};
